import { render } from "./VetData.vue?vue&type=template&id=4704c508&scoped=true&ts=true"
import script from "./VetData.vue?vue&type=script&lang=ts"
export * from "./VetData.vue?vue&type=script&lang=ts"

import "./VetData.vue?vue&type=style&index=0&id=4704c508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4704c508"]])

export default __exports__